<template>
    <div id="backgroundPanel" class="AssignmentTitle">
        <div id="logo"></div>
        <div id="titleText">
            <span id="TitleLabel">{{ assignmentTitle }}</span>
            <span id="HelpSpan" class="TitleDescription">
                <a id="HelpLinkButton" href="#" @click.prevent="onHelpLinkClicked">Help</a>
            </span>
        </div>
    </div>
</template>

<script>
    import Auth from '../services/Auth';

    export default {
        props: { 
            assignmentTitle: {
                type: String,
                default: null
            }
        },
        data()
        {
            return { }
        },
        methods: {
            onHelpLinkClicked: function () {
                console.error("helpLinkButtonClicked not implemented");
            }
        }
    }
</script>
